export const REDUCER_NAME="beneficiarySlice"
export interface iBeneficiaryDTO {
  beneficiaryId?: string;
  accountHolderName?: string;
  bankAccountNumber?: string;
  ifscCode?: string;
}

export interface iBeneficiaryResponse extends iBeneficiaryDTO {
  id: string;
  userId: string;
  verified: boolean;
  createdAt: string;
  updatedAt: string;
}
export interface iBeneficiaryState {
      isLoading: boolean;
      beneficiaryList: iBeneficiaryResponse[];
      errorMessage: string | null;
    }